import { render, staticRenderFns } from "./MaterialDonationConfirmationModal.vue?vue&type=template&id=6caab8e3&"
import script from "./MaterialDonationConfirmationModal.vue?vue&type=script&lang=js&"
export * from "./MaterialDonationConfirmationModal.vue?vue&type=script&lang=js&"
import style0 from "./MaterialDonationConfirmationModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports